__turbopack_context__.v({
  "container": "InstagramCount-module__iRP9pq__container",
  "count": "InstagramCount-module__iRP9pq__count",
  "fadeInItems": "InstagramCount-module__iRP9pq__fadeInItems",
  "icon": "InstagramCount-module__iRP9pq__icon",
  "marquee": "InstagramCount-module__iRP9pq__marquee",
  "spacing--lg": "InstagramCount-module__iRP9pq__spacing--lg",
  "spacing--md": "InstagramCount-module__iRP9pq__spacing--md",
  "spacing--sm": "InstagramCount-module__iRP9pq__spacing--sm",
  "spacing--xl": "InstagramCount-module__iRP9pq__spacing--xl",
  "spacing--xs": "InstagramCount-module__iRP9pq__spacing--xs",
  "spacing--xxl": "InstagramCount-module__iRP9pq__spacing--xxl",
  "spacing--xxs": "InstagramCount-module__iRP9pq__spacing--xxs",
  "spacing--xxxl": "InstagramCount-module__iRP9pq__spacing--xxxl",
  "spacing--xxxs": "InstagramCount-module__iRP9pq__spacing--xxxs",
  "user": "InstagramCount-module__iRP9pq__user",
  "userText": "InstagramCount-module__iRP9pq__userText",
});
